import { Injectable } from '@angular/core';
import { BuildingContact } from '../model/building-contact';
import { ApiRouteConfig } from '../../../config/api.route.config';
import {HttpClient, HttpParams} from '@angular/common/http';
import {AppConfig} from '../../../config/app.config';
import {map, tap} from 'rxjs/operators';
import {PaginationResponse} from '../model/pagination-response';
import { Subject, Observable } from 'rxjs';
import {BuildingSummary} from "../model/building-summary";

@Injectable()
export class BuildingsContactsService {

  deleted$ = new Subject<any>();
  added$ = new Subject<BuildingContact>();

  constructor(private httpClient: HttpClient, private config: ApiRouteConfig, private appConfig: AppConfig) {
  }

  private getDefaultAvatarUrl(): string {
    return this.appConfig.DEFAULT_AVATAR_URL;
  }

  getContacts(httpParams: HttpParams, bid: string, pageNumber: number, pageSize: number): Observable<PaginationResponse<BuildingContact>> {
    const params = httpParams
      .append('pageNumber', pageNumber.toString())
      .append('pageSize', pageSize.toString());
    return this.httpClient.get<PaginationResponse<BuildingContact>>(this.config.getRouteWithInjectedParams(this.config.BUILDING_CONTACTS, [bid]), {params}).pipe(
      map(response => {
        response.content.map(contact => {
          if (contact.photoUrl == null) {
            contact.photoUrl = this.getDefaultAvatarUrl();
          }
        });
        return response;
      })
    );
  }

  createContact(payload: any): Observable<BuildingContact> {
    this.setContactOrganizationToNullIfItsEmptyString(payload.contact);
    return this.httpClient.put<BuildingContact>(this.config.BUILDING_CONTACTS, payload).pipe(
      tap(c => this.added$.next(c))
    );
  }
  
  buildings(contactId: number): Observable<BuildingSummary[]> {
    return this.httpClient.get<BuildingSummary[]>(this.config.getRouteWithInjectedParams(this.config.RESIDENT_BUILDINGS, [`${contactId}`]), {withCredentials: true});
  }

  private setContactOrganizationToNullIfItsEmptyString(contact: BuildingContact) {
    if (contact.company === '') {
      contact.company = null;
    }
  }
}
